import api from './api';

const CompanyService = {
    get: () => api.get('/company').then(r => r.data),
    update: (payload) => api.put('/company', payload).then(r => r.data),
    uploadLogo: (file) => {
        const form = new FormData();
        form.append('file', file);
        return api.put('/company/logo', form).then(r => r.data);
    },
    deleteLogo: () => api.delete('/company/logo').then(r => r.data),
    logoBlob: () => api.get('/company/logo', { responseType: 'blob' }).then(r => r.data),
};

export default CompanyService;
